export default "__VITE_ASSET__ZXjTskR5__"